import { render, staticRenderFns } from "./RemoveImageReason.vue?vue&type=template&id=56b87300"
import script from "./RemoveImageReason.vue?vue&type=script&lang=js"
export * from "./RemoveImageReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports